<div id="vista-de-popup" class="common-company-popup popup-md">
    <form class="form" role="form" autocomplete="off" [formGroup]="visitaEmpresaForm">
        <div class="popoup-hearder">
            <h2 class="m-b-5" mat-dialog-title>Visita de empresa</h2>
        </div>
        <div class="popoup-content">
            <div class="block-looper">
                <div class="form-wrap w20 d-pick">
                    <mat-label aria-label="" class="label">Fecha</mat-label>
                    <mat-form-field appearance="fill">
                        <input matInput [matDatepicker]="picker" formControlName="Fecha">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                    <mat-error *ngIf="visitaEmpresaForm.get('Fecha').invalid && visitaEmpresaForm.get('Fecha').touched">
                        <span *ngIf="visitaEmpresaForm.get('Fecha').hasError('required')">La fecha es obligatoria</span>
                    </mat-error>
                </div>
                <div class="form-wrap w30">
                    <mat-label aria-label="" class="label">Tipo</mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select formControlName="Tipo">
                            <mat-option *ngFor="let type of tipoList" [value]="type.value">
                                {{ type.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="visitaEmpresaForm.get('Tipo').invalid && visitaEmpresaForm.get('Tipo').touched">
                        <span *ngIf="visitaEmpresaForm.get('Tipo').hasError('required')"> El tipo es obligatorio</span>
                    </mat-error>
                </div>
                <div class="form-wrap w50">
                    <mat-label aria-label="" class="label">Autor</mat-label>
                    <mat-form-field appearance="fill">
                        <mat-select placeholder="" formControlName="Autor">
                            <mat-option *ngFor="let coordinator of coordinatorList" [value]="coordinator.viewValue">
                                {{ coordinator.viewValue }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-error *ngIf="visitaEmpresaForm.get('Autor').invalid && visitaEmpresaForm.get('Autor').touched">
                        <span *ngIf="visitaEmpresaForm.get('Autor').hasError('required')">El autor es obligatorio</span>
                    </mat-error>
                </div>

                <div class="f-w">
                    <div class="form-wrap w50">
                        <mat-label class="label">Asunto</mat-label>
                        <mat-form-field appearance="fill">
                            <input type="text" matInput formControlName="Asunto" maxlength="200">
                        </mat-form-field>
                    </div>
                    <div class="form-wrap w50">
                        <mat-label class="label">Asistentes</mat-label>
                        <mat-form-field appearance="fill">
                            <input type="text" matInput formControlName="Asistentes" maxlength="400">
                        </mat-form-field>
                    </div>
                </div>
                <div class="f-w">
                    <div class="form-wrap w50">
                        <mat-label class="label">Asistentes de la Empresa</mat-label>
                        <span class="assis-empresa">
                        <mat-form-field appearance="fill">
                            <input type="text" matInput formControlName="AsistentesEmpresa" autocomplete="off">
                        </mat-form-field>
                        <button (click)="openAddEditPopup()" mat-icon-button class="navbar-toggle-button">
                            <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">more_vert</mat-icon>
                        </button>
                    </span>
                    </div>
                    <div class="form-wrap w50">
                        <mat-label class="label">Asistentes de la Mutua</mat-label>
                        <mat-form-field appearance="fill">
                            <input type="text" matInput formControlName="AsistentesMutua" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div>

                <!-- <div class="f-w">
                    <div class="form-wrap w50  d-flex">
                        <mat-form-field class="w-100-p">
                            <mat-label class="label">Asistentes de la Empresa</mat-label>
                            <input type="text" matInput formControlName="AsistentesEmpresa" autocomplete="off">
                        </mat-form-field>
                        <button (click)="openAddEditPopup()" mat-icon-button class="navbar-toggle-button">
                            <mat-icon class="mat-icon material-icons mat-icon-no-color f-s-19">more_vert</mat-icon>
                        </button>
                    </div>
                    <div class="form-wrap w50">
                        <mat-form-field class="w-100-p">
                            <mat-label class="label">Asistentes de la Mutua</mat-label>
                            <input type="text" matInput formControlName="AsistentesMutua" autocomplete="off">
                        </mat-form-field>
                    </div>
                </div> -->
                <div class="form-wrap">
                    <mat-label aria-label="" class="label">Comentarios</mat-label>
                    <mat-form-field appearance="fill">
                        <textarea matInput placeholder="" rows="4" formControlName="Comentarios"></textarea>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="popoup-footer">
            <button class="keep" (click)="onSubmit()"><span class="mat-button-wrapper">Guardar</span></button>
            <button class="cancel" (click)="cancel(false)"><span class="mat-button-wrapper">Cancelar</span></button>
        </div>
    </form>
</div>